import { render, staticRenderFns } from "./VrstaTemeForma.vue?vue&type=template&id=f220b50a&scoped=true&"
import script from "./VrstaTemeForma.vue?vue&type=script&lang=js&"
export * from "./VrstaTemeForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f220b50a",
  null
  
)

export default component.exports